import React from 'react';
import { SubscriptionPackage } from '../../apis/subscriptionApi'
import './subscriptionSelector.css';
import ToggleContent from '../ToggleContent';

interface Props {
    subscriptions: SubscriptionPackage[];
    selectedSubscriptionId: number | null;
    onSelectSubscription: (subscriptionId: number, amount: number) => void;
}

const SubscriptionSelector: React.FC<Props> = ({ subscriptions, selectedSubscriptionId, onSelectSubscription }) => {
    const handleSelectSubscription = (subscriptionId: number, amount: number) => {
        onSelectSubscription(subscriptionId, amount);
    };

    return (
        <div>
            <br/>
            <strong><h2>Select a Subscription</h2></strong>
            <br/>
            <div className="subscription-container">
                {subscriptions.map(subscription => (
                    <div
                        key={subscription.id}
                        className={`subscription-card ${selectedSubscriptionId === subscription.id ? 'selected' : ''}`}
                        onClick={() => handleSelectSubscription(subscription.id, subscription.price)}
                    >
                        <h3 className="subscription-name">{subscription.name}</h3>
                        <ToggleContent content={subscription.description} title='Features included' /><br/>
                        <p className="subscription-price">Price: ${subscription.price}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SubscriptionSelector;